import { Validator } from 'vee-validate';

export const validate = () => {
    // const dictionary = {
    //   en: {
    //     messages: {
    //       email: () => '邮箱格式不正x确哦'
    //     }
    //   }
    // };
    // Validator.updateDictionary(dictionary);
    return {
      methods: {
        addValidator(name, reg, errText, bool = true) {
          Validator.extend(name, {
            messages: { en: errText },
            validate: value => {
              return bool?reg.test(value):!reg.test(value)
            }
          })
        },
        newFileObj(index, postAction, fileName, imgName, num) {
          return {
            files: [],
            accept: 'image/png,image/gif,image/jpeg,image/webp',  // 表单的accept属性, MIME type
            size: 1024 * 1024 * 10,  // 允许上传的最大字节
            extensions: 'gif,jpg,jpeg,png,webp',  // 允许上传的文件后缀   其他用法  ['gif', 'jpg', 'jpeg','png', 'webp']   /\.(gif|jpe?g|png|webp)$/i
            multiple: false,  // 是否允许选择多个文件
            directory: false,  // 是否是上传文件夹
            drop: false,  // 拖拽上传  如果设置成 true 则读取父组件作为容器
            dropDirectory: false,  // 拖拽上传  如果设置成 true 则读取父组件作为容器
            thread: 0,  // 拖拽上传 如果设置成 true 则读取父组件作为容器
            name: `file${index}`,  // input标签的 name 属性
            postAction:  postAction, // POST 请求的上传URL
            putAction: '',  // PUT 请求的上传URL  如果使用请先填写put
            data: {},  // 传参
            auto: false,
            sel: false,
            selErr: false,
            inputFilter: (newFile, oldFile, prevent) => {        //证件正面照片上传
              this.$refs["upload"+num].active = true  // 开启上传
              console.log(this.$refs["upload"+num])
              this.formMsgArr[imgName] = this[fileName].files[0].response.name;
            }
          }
        },
        compareYear(birthday, min, max = null) {  //  this.compareYear(this.$moment("1988-10-5"),18,30)
          var nowDate = this.$moment()
          var year = nowDate.get('year')
          var month = nowDate.get('month') + 1
          var day = nowDate.get('date')
  
          var befYear = birthday.get('year')
          var befMonth = birthday.get('month') + 1
          var befday = birthday.get('date')
  
          var date = `${year}-${month}-${day}`
          var beforeDateMin = `${befYear + min}-${befMonth}-${befday - 1}`
          if (max) {
            var beforeDateMax = `${befYear + max}-${befMonth}-${befday + 1}`
            return this.$moment(date).isBetween(beforeDateMin, beforeDateMax, 'date')
          } else {
            return this.$moment(date).isAfter(beforeDateMin, 'date')
          }
        }
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/common/mixin/validate.js